import { Directive, Renderer2, ElementRef, Component, Input, HostListener, OnInit } from '@angular/core';
import { ResizeEvent } from 'angular-resizable-element';
import { ResizedEvent } from 'angular-resize-event';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'resizable-column-control',
  template: `
  <div mwlResizable [enableGhostResize]="true" [resizeEdges]="{right: true }" (resized)="onResized($event)"
       [ngStyle]="{'width': width > 0 ? width + 'px':'100px'}"  (mousedown)= "resizeColumn($event)">
        <div> {{tile}}</div>
  </div>
`
})
export class ResizableColumnControlComponent implements OnInit {

  el: ElementRef;
  constructor(el: ElementRef, private renderer: Renderer2) {
    this.el = el;
  }

  @Input() autoadjust: boolean;
  parent: any;
  @Input() tile: string;
  @Input() width = 0;
  onChange;
  start: any = undefined;
  pressed = false;
  startX: any;
  startWidth: any;
  resizableFnMousemove: () => void;
  resizableFnMouseup: () => void;

  onAutoadjust(event: any) {
    this.width = event.newWidth;
  }

  onResized(event: ResizedEvent): void {
    if (!this.autoadjust) {
      this.width = event.newWidth;
      this.parent = this.getResizableParent();
      if (this.parent) {
        this.renderer.setStyle(this.parent, 'width', this.width + 'px');
      }
    }
  }

  onResizeColumn(fn: any): void {
    this.onChange = fn;
  }

  resizeColumn(event: any) {
    this.start = event.target;
    this.pressed = true;
    this.startX = event.pageX;
    this.startWidth = this.start.clientWidth;
    this.setSearchTableFixed();
    this.mouseMove();
  }

  getResizableParent(): any {
    const clickedComponent = this.el.nativeElement.parentNode;
    if (clickedComponent.classList.contains('resizable-column')) {
      return clickedComponent;
    } else {
      return null;
    }
  }

  setSearchTableFixed(): void {
    let clickedComponent = this.el.nativeElement.parentNode;
    let searchTable: any;
    do {
      if (clickedComponent && clickedComponent.classList && clickedComponent.classList.contains('search-table')) {
        searchTable = clickedComponent;
      }
      if (!searchTable) {
        clickedComponent = clickedComponent.parentNode;
      }
    } while (clickedComponent && !searchTable);

    if (searchTable && !clickedComponent.classList.contains('search-table-fixed')) {
      searchTable.classList.add('search-table-fixed');
    }
  }

  mouseMove() {
    this.resizableFnMousemove = this.renderer.listen('document', 'mousemove', (event) => {
      if (this.pressed) {
        const width = this.startWidth + (event.pageX - this.startX);
        const index = this.start.cellIndex;
        this.width = width;
        this.parent = this.getResizableParent();
        if (this.parent) {
          this.renderer.setStyle(this.parent, 'width', width + 'px');
        }
      }
    });

    this.resizableFnMouseup = this.renderer.listen('document', 'mouseup', (event) => {
      if (this.pressed) {
        this.pressed = false;
        this.resizableFnMousemove();
        this.resizableFnMouseup();
      }
    });
  }

  ngOnInit(): void {

  }
}
